import { render, staticRenderFns } from "./HomekindLogo.vue?vue&type=template&id=ffd0b3e8&scoped=true"
import script from "./HomekindLogo.vue?vue&type=script&lang=js"
export * from "./HomekindLogo.vue?vue&type=script&lang=js"
import style0 from "./HomekindLogo.vue?vue&type=style&index=0&id=ffd0b3e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd0b3e8",
  null
  
)

export default component.exports